<template>
  <div class="puntoControl_wrapper">
    <headView :option="title" :subtitleOpt="subtitleOpt">
      <headButton :option="buttonOptions" v-if="roleEdit"></headButton>
    </headView>
    <div class="table-section">
      <b-table
        class="table-history"
        :data="dataTable ? dataTable : []"
        default-sort-direction="asc"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Punto de Control" :title="props.row.name">
            <div class="table-column table-column--left table-column--name">
              <div>
                <p style="font-weight: bold;">{{ props.row.name }}</p>
                <p v-if="props.row.type"><small :style="{color: props.row.typeColor, fontSize: '0.8rem', fontWeight:'bold'}">{{ props.row.type }}</small></p>
              </div>
            </div>
          </b-table-column>

          <b-table-column field="created" label="Creado por" width="200">
            <div class="table-column table-column--left table-column--author">
              {{ props.row.user }}
            </div>
          </b-table-column>

          <b-table-column
            field="fechaCreacion"
            label="Fecha de Creación"
            width="200"
            centered
          >
            <div class="table-column table-column--center">
              {{ props.row.fechaCreacion }}
            </div>
          </b-table-column>

          <b-table-column field="action" width="200" centered>
            <div class="table-button" v-if="roleEdit">
              <a
                @click.prevent.stop="updateView(props.row.checkpoint)"
                class="button-edit-table"
                >EDITAR</a
              >
            </div>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
              </p>
              <p>No hay datos.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import headButton from "../Componentes/headButton";
import { mapGetters } from "vuex";
export default {
  name: "PuntoControl",
  components: {
    headView,
    headButton,
  },
  data() {
    return {
      title: {
        headText: "Puntos de Control",
        subtitle: "",
      },
      subtitleOpt: false,
      buttonOptions: {
        btnAction: true,
        valueBtn: "nuevo punto de control",
        ruta: "crearpuntocontrol",
        btnType: "create",
      },
      cpHeaders: ["punto de control", "creado por", "fecha creación", ""],
      width: ["25%", "25%", "25%"],
      data: [],
    };
  },
  created() {
    this.$store.dispatch("GETCHECKPOINTS");
    this.$store.commit("resetTasks");
  },
  computed: {
    ...mapGetters(["puntosControl", "roleEdit", "getUserName"]),
    dataTable() {
      if (this.puntosControl) {
        this.data = this.puntosControl.map((cp) => {
          // console.log(cp);

          let obj = {
            name: cp.name,
            // user: cp.autor? this.getUserName(cp.autor) :"Carlos Eduardo Angulo",
            user: "--",
            fechaCreacion: "10/12/18 15:45",
            checkpoint: cp.id,
            type: cp.typification ? cp.typification.name : '',
            typeColor: cp.typification ? cp.typification.color : '',
          };
          // console.log(obj);

          return obj;
        });
        return this.data;
      }
      return []
    },
  },
  methods: {
    updateView: function (id) {
      this.$store
        .dispatch("GETCHECKPOINT", {
          id_company: this.$store.getters.company_id,
          id_checkpoint: id,
          namespace: this.$store.state.namespace
        })
        .then((response) => {
          this.$router.push({ name: "updatepuntocontrol", params: { id: id } });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/2.tools/mixins/_mediaquerys";
.puntoControl_wrapper {
  margin-top: 100px;
}
.puntoControl_list {
  display: flex;
  max-width: 800px;
  min-width: 400px;
  flex-flow: row wrap;
}
.puntoControl_list__item {
  margin: 10px 0px 10px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 350px;
  border: thin solid #e6e4e6;
  padding: 10px 20px;
}
.list_item-boton,
.list_item-boton:active {
  border: none;
  background-color: inherit;
  color: darkturquoise;
}
.edit-icon {
  color: #50a3ff;
}
.tableCheckPoint {
  padding: 0 100px 0 20px;
}
.button-edit-table {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
}
.table-button,
.table-column {
  // height: 55px;
  display: flex;
  justify-content: center;
}
.table-column--left {
  min-width: 100px;
  max-width: 100px;
  justify-content: flex-start;
  align-items: center;
  @include media-lg() {
    min-width: 230px;
    max-width: 230px;
  }
  @include media-xl() {
    min-width: 300px;
    max-width: 300px;
  }
}
.table-column--center {
  min-width: 150px;
  max-width: 150px;
  align-items: center;
  @include media-xl() {
    min-width: 300px;
    max-width: 300px;
  }
}
.table-column--author {
  min-width: 150px;
  max-width: 150px;
  @include media-xl() {
    min-width: 250px;
    max-width: 250px;
  }
}
.table-column--name {
  // white-space: nowrap;
  overflow: hidden;
  min-width: 350px;
  max-width: 350px;
  // text-overflow: ellipsis;
}
.table-section {
  margin: 0 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/PuntoControl.vue